import { UserManager, WebStorageStateStore, Log } from 'oidc-client-ts'

import store from '../../store.js'
import server from '../api/server.js'

class Auth {
  constructor(oidcConfig) {
    // This helps to debug UserManager issues
    /* Log.setLogger(console)
    Log.setLevel(Log.INFO) */
    const url = window.location.origin
    this.userManager = new UserManager({
      authority: oidcConfig.issuer,
      client_id: oidcConfig.clientId,
      client_secret: oidcConfig.clientSecret,
      redirect_uri: `${url}/login-callback`,
      silent_redirect_uri: `${url}/login-callback-silent.html`,
      post_logout_redirect_uri: `${url}`,
      response_type: 'code',
      scope: oidcConfig.scope,
      prompt: oidcConfig.prompt,
      extraQueryParams: oidcConfig.extraQueryParams,
      monitorSession: false,
      userStore: new WebStorageStateStore({ store: window.localStorage })
    })

    this.userManager.metadataService.getEndSessionEndpoint().then(url => { this.canEndSession = !!url })
    this.userManager.clearStaleState()
  }

  async getUser() {
    return await this.userManager.getUser()
  }

  async login(state) {
    await this.userManager.signinRedirect({
      state,
      useReplaceToNavigate: true
    })
  }

  async handleLoginCallback() {
    const user = await this.userManager.signinRedirectCallback()
    return user.state
  }

  async logoutAction(logoutFromRDSSToo) {
    // console.log('calling logout in rssp')
    if (this.canEndSession) {
      // console.log('rssp canEndSession: true')
      let params
      if (logoutFromRDSSToo) {
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        params = { post_logout_redirect_uri: rdssPublicUrl + 'logoutOnlySelf' }
      }
      await this.userManager.signoutRedirect(params)
    } else {
      // console.log('rssp canEndSession: false')
      await this.userManager.removeUser()
      if (logoutFromRDSSToo) {
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'logoutOnlySelf'
      }
    }
    // store.commit('removeCurrentUser') //addUserUnloaded elvileg meghívja
  }

  async logout() {
    const logoutFromRDSSToo = !!store.state.remoteConfig.rdssApiUrl
    this.logoutAction(logoutFromRDSSToo)
  }

  async logoutOnlySelf() {
    await this.userManager.removeUser()
  }

  async getAccessToken(forceRefresh = false) {
    const user = await this._getRefreshingUser(forceRefresh)
    return user.access_token
  }

  async getIdToken(forceRefresh = false) {
    const user = await this._getRefreshingUser(forceRefresh)
    return user.id_token
  }

  addUserLoaded(func) {
    this.userManager.events.addUserLoaded(func)
  }

  addUserUnloaded(func) {
    this.userManager.events.addUserUnloaded(func)
  }

  async _getRefreshingUser(forceRefresh = false) {
    let user = await this.userManager.getUser()
    if (forceRefresh || !user || user.expired) {
      try {
        user = await this.userManager.signinSilent()
      } catch (error) {
        await this.userManager.removeUser()
        throw error
      }
    }

    return user
  }
}

async function createAuth() {
  const resp = await server.getOidcConfig('web')
  return new Auth(resp)
}

export default createAuth
